import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Nouto',
        [ORDER_METHODS.DELIVERY]: 'Toimitus',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Huonepalvelu',
          [RoomServiceLocationType.TableService]: 'Pöytäpalvelu',
        },
      },
    },
    delivery_info: {
      title: 'Toimitustiedot',
      on_arrival: 'Saapuessa:',
    },
    customer_info: {
      title: 'Yhteystiedot',
    },
    payment: {
      title: 'Maksu',
    },
    request_invoice: {
      title: 'Pyydä lasku',
      form: {
        is_receipt_required: {
          label: 'Pyydä lasku sähköpostitse',
        },
      },
    },
    location: {
      title: 'Liikkeen osoite',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Toimitusosoite',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Paikan osoite',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Noutopaikan osoite',
      },
    },
    method: {
      title: 'Tapa',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Toimitus',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Paikan päällä',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Nouto',
      },
    },
    time: {
      title: 'Aika',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Normaali {{time}} min, tänään',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Ajasta myöhemmäksi',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Huoneen numero',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Pöydän numero',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Soita ovikelloa',
        [DropoffAction.Sms]: 'Ota minuun yhteyttä tekstiviestillä saapuessa',
      },
    },
    doorbell_name: {
      placeholder: 'Ovikellon nimi (valinnainen)',
    },
    company_name: {
      placeholder: 'Yrityksen nimi (valinnainen)',
    },
    customer_note: {
      placeholder: 'Toimitusohjeet (valinnainen)',
    },
    order_instructions: {
      placeholder: 'Kirjoita tilausohjeet...',
    },
  },
  buttons: {
    change: 'Muuta',
    edit: 'Muokkaa',
    done: 'Valmis',
    add_delivery_note: '+ Lisää toimitustiedot',
    add_order_instructions: '+ Lisää tilausohjeet',
  },
  summary: {
    doorbell: 'Ovikello',
    company: 'Yritys',
    note: 'Huomautus',
    instructions: 'Ohjeet',
  },
};
